export default __webpack_public_path__ + "static/pattern_04-7f991d902423db8ac329f0c649e2ae30.png";